import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FinancialInstitutionPatternSchema = withDefaults({
  type: 'financial-institution-pattern',
  fields: [
    {
      kind: 'attribute',
      name: 'pattern',
    },
    {
      kind: 'attribute',
      name: 'docTypes',
    },
    {
      kind: 'attribute',
      name: 'observableDocumentsCount',
    },
    {
      kind: 'attribute',
      name: 'ignored',
    },
    {
      kind: 'belongsTo',
      name: 'financialInstitution',
      type: 'financial-institution',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default FinancialInstitutionPatternSchema;
